import { FormattedMessage } from "react-intl";
import { NAVIGATE } from "../../Router";
import "./adsbanners.css";

function WebcamBanner() {
  return (
    <button
      type="button"
      onClick={() => NAVIGATE.navigate && NAVIGATE.navigate("/webcams")}
      className="insite-ads-banner-card w-full max-w-[320px] rounded-2xl border border-white/40 bg-gradient-to-r from-[#06b6d4] via-[#14b8a6] to-[#22c55e] px-4 py-3 text-left shadow-[0_18px_40px_rgba(16,185,129,0.35)] transition-transform duration-300 hover:-translate-y-1 sm:max-w-[728px] sm:px-6 sm:py-4"
    >
      <div className="insite-ads-banner-shine" />
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex flex-col gap-2 sm:block">
          <p className="text-xs uppercase tracking-[0.4em] text-white/80">
            <FormattedMessage id="ads_webcam_kicker" defaultMessage="Live now" />
          </p>
          <h3 className="text-xl font-black text-white sm:text-3xl">
            <FormattedMessage
              id="ads_webcam_title"
              defaultMessage="Meet creators on webcam"
            />
          </h3>
          <p className="text-xs text-white/90 sm:text-sm">
            <FormattedMessage
              id="ads_webcam_body"
              defaultMessage="Jump into live sessions and connect instantly."
            />
          </p>
        </div>
        <div className="mt-3 inline-flex items-center gap-2 self-end rounded-full bg-white px-4 py-2 text-xs font-bold text-[#0f766e] shadow-sm sm:mt-0 sm:self-center sm:px-5 sm:py-2 sm:text-sm">
          <FormattedMessage id="ads_webcam_cta" defaultMessage="Enter live" />
          <span aria-hidden>→</span>
        </div>
      </div>
    </button>
  );
}

export default WebcamBanner;
